import { render, staticRenderFns } from "./control6Literature.vue?vue&type=template&id=860552be&scoped=true&"
import script from "./control6Literature.vue?vue&type=script&lang=js&"
export * from "./control6Literature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "860552be",
  null
  
)

export default component.exports